<div class="inner" [class.no-avatar]="!showAvatarPhoto()">
  @if (showAvatarPhoto()) {
  <div class="avatar">
    <div class="avatar-photo">
      <qai-avatar
        [size]="'3xlarge'"
        [photoUrl]="avatarPhotoUrl()"
        [fullName]="'John Doe'"
        [fallback]="'placeholder'"
        [speaking]="isAvatarSpeaking()"
      ></qai-avatar>
      @if (aiNotice(); as aiNotice) {
      <qai-badge class="ai-notice" kind="gray-dark" shape="rectangle" size="xsmall" [label]="aiNotice" />
      }
    </div>
  </div>
  }

  @if (showSubtitles()) {
  <div class="subtitles">
    <qai-subtitles
      [kind]="resolvedSubtitleKind()"
      [subtitleText]="resolvedSubtitleText()"
      [formatting]="subtitleFormatting()"
      [icon]="subtitleIcon()"
    ></qai-subtitles>
  </div>
  }

  <div class="controls">
    <ng-content select="app-pathway-call-controls" />
  </div>
</div>
